import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { AutocompleteOption, Header, Page, Toolbox } from 'redesign';
import { FormProvider, useForm } from 'react-hook-form';
import { useDebounce } from 'shared/hooks/use-debounce';
import { EmploymentType } from '@types';
import { useTranslation } from 'react-i18next';
import { AddDocumentFormToolbox } from './add-document-form-toolbox';
import { DocumentFormHQ, DocumentFormTypes } from './document-form';
import { useGetWorkerList } from '../../../../../hq/hooks/queryHooks/flexWorkers/use-get-flex-worker-list';

export const AddDocumentFormDataProvider = () => {
  const { t } = useTranslation('hq-screen-specific');
  const [flexWorkerSearchValue, setFlexWorkerSearchValue] = useState<string>('');
  const [flexWorkerSelectedOption, setFlexWorkerSelectedOption] =
    useState<AutocompleteOption | null>(null);

  const formMethods = useForm<DocumentFormTypes>({
    defaultValues: {
      documentType: null,
      startDate: null,
      endDate: null,
      flexWorkerOption: null,
    },
  });

  useEffect(() => {
    formMethods.setValue('flexWorkerOption', flexWorkerSelectedOption);
  }, [flexWorkerSelectedOption]);
  const debouncedFlexWorkerSearchValue = useDebounce(flexWorkerSearchValue, 300);
  const flexWorkersQuery = useGetWorkerList(
    debouncedFlexWorkerSearchValue,
    EmploymentType.TEMPWORKER
  );

  return (
    <FormProvider {...formMethods}>
      <Page
        header={<Header titleText={t('document_create.page_title')} />}
        toolbox={
          <Toolbox>
            <AddDocumentFormToolbox />
          </Toolbox>
        }
      >
        <Box>
          <DocumentFormHQ
            flexWorkers={flexWorkersQuery.data || []}
            formState="create"
            flexWorkerOption={flexWorkerSelectedOption}
            flexWorkerSearch={flexWorkerSearchValue}
            setFlexWorkerOption={setFlexWorkerSelectedOption}
            setFlexWorkerSearch={setFlexWorkerSearchValue}
          />
        </Box>
      </Page>
    </FormProvider>
  );
};
